import { ReportProblem } from '@/shared-ui';

import ProjectResponseRanking from './project-response-ranking';
import { ProjectResponseComponentProps } from './project-response-renderer.type';

const EMPTY_OPTIONS: NonNullable<ProjectResponseComponentProps['options']> = [];

export function ProjectResponseRankingRendererComponent({
  id,
  app,
  text,
  options = EMPTY_OPTIONS,
  value,
  onChange,
  readonly,
  assets,
  audio,
  isAiVoiceEnabled,
  isFollowUp = false,
  onSubmit,
  questionId,
}: ProjectResponseComponentProps) {
  return (
    <div
      data-test='ranking-renderer'
      className='isolate flex w-full flex-col gap-1'
    >
      <ProjectResponseRanking
        app={app}
        values={options}
        value={value ?? ''}
        onChange={onChange}
        readonly={readonly}
        assets={assets}
        text={text}
        audio={audio}
        isAiVoiceEnabled={isAiVoiceEnabled}
      />
      {onSubmit && id && (
        <ReportProblem
          context={{ messageId: id, questionId: questionId ?? undefined }}
          onSubmit={onSubmit}
          variant={isFollowUp ? 'follow-up' : 'main'}
          className='self-start'
        />
      )}
    </div>
  );
}
